import styled from "styled-components";

const Wrap = styled.div`
  min-height: 240px;
  display: grid;
  place-items: center;
  color: #6f7d95;
`;

export const LoadingView = () => <Wrap>Loading...</Wrap>;

